<template>
  <div @click="handleClickOpenDropdown" class="dropdown-final-filters-area">
    <v-select 
      :class="['dropdown-final-filters', {disabledSelect: noDropSelect}]" 
      ref="select"
      :options="options" 
      :multiple="false" 
      :value="valueDropdown"
      :label="label"
      :searchable="true"
      @input="onClickSelectOption"
      :key="forceRerenderDropdown"
      :noDrop="noDropSelect"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import rooms from "../../constants/rooms";
import passions from "../../constants/passions";

export default {
  name: "DropdownFinalFilters",
  components: {vSelect},
  props: [
    "sendAnalytics", 
    "keyDropdown", 
    "roomSelected", 
    "passionSelected", 
    "featureSelected", 
    "featuresByPassion",
    "open"
  ],
  data() {
    return {
      options: [],
      valueDropdown: {},
      label: '',
      forceRerenderDropdown: 0,
      noDropSelect: false,
    };
  },
  computed: {},
  watch: {
    roomSelected: {
      handler(){
        rooms.map(room => {
          if(room.name === this.roomSelected.name){
            this.valueDropdown = room;
          }
        });
      }
    },
    passionSelected: {
      handler(){
        passions.map(passion => {
          if(passion.title === this.passionSelected){
            this.valueDropdown =  passion;
          }
        });
      }
    },
    featureSelected: {
      handler(){
        this.featuresByPassion.map(feature => {
          if(feature.name === this.featureSelected){
            this.valueDropdown = feature;
          }
        });
      }
    },
    featuresByPassion: {
      handler(){
        if(this.keyDropdown === 'features'){
          if(this.passionSelected != "todos"){
            this.noDropSelect = false;
            this.options = null;
            this.options = this.featuresByPassion;
            this.valueDropdown = "";
            this.label = 'breadcrumbName';
          }else{
            this.noDropSelect = true;
            this.options = null;
            this.options = [];
            this.valueDropdown = "Todos"
          }
        }
      }
    },
    open: {
      handler(){
        if(this.open === this.keyDropdown){
          this.$refs.select.open = true;
        }else{
          this.$refs.select.open = false;
        }
      }
    }
  },
  mounted() {
    switch(this.keyDropdown){
      case "rooms": 
        this.options = rooms;
        this.label = 'name';
        rooms.map(room => {
          if(room.name === this.roomSelected.name){
            this.valueDropdown = room;
          }
        })
        break;
      case "passions": 
        this.options = passions;
        this.label = 'displayName';
        passions.map(passion => {
          if(passion.title === this.passionSelected){
            this.valueDropdown = passion;
          }
        })
        break;
      case "features":
        this.options = this.featuresByPassion;
        if(this.featuresByPassion.length === 0){
          this.valueDropdown = "Todos"
          this.noDropSelect = true;
        }else{
          this.label = 'breadcrumbName';
          this.options.map(feature => {
            if(feature.name === this.featureSelected){
              this.valueDropdown = feature;
            }
          })
        }
        break;
    }
  },
  methods: {
    onClickSelectOption(option){
      this.$emit('changeFinalFilters', {option, key: this.keyDropdown});

      this.openDropdown = false;
    },
    handleClickOpenDropdown(){
      this.$emit('handleOpenDropdown', this.keyDropdown);
    }
  },
};
</script>

<style >
  .vs--unsearchable .vs__search{
    width: 0;
  }
  
  .dropdown-final-filters-area{
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
  }

  .dropdown-final-filters{
    display: flex;
    justify-content: center;
    align-items: center;

    height: 60px;
    width: 90%;

    margin-top: 1.5rem;

    border: 1px solid #000;
    border-radius: 150px;

    background-color: #FFF;
  }

  .dropdown-final-filters .vs__search {    
    width: 100%;
    font-family: "SamsungOneBold";
    font-size: 1.2rem;
    background-color: #FFF;

    margin: 0;
    padding: 0;
  }

  .dropdown-final-filters .vs__dropdown-toggle{
    width: 100%;
    height: 49px;
    padding: 0;
    border: 0;

    margin: 1rem;
  }

  .dropdown-final-filters  .vs__dropdown-menu{
    width: 85%;
    left: 7.5%;

    border-radius: 0 0 1.5rem 1.5rem;
  }

  .dropdown-final-filters  .vs__dropdown-menu .vs__dropdown-option{
    line-height: 4rem;
    font-family: "SamsungOneBold";
    font-size: 1rem;
  }
  
  .dropdown-final-filters .vs__selected-options{
    padding: 0;
    background-color: #FFF;

    flex-wrap: nowrap;
    max-width: calc(100% - 25px); /* change this to `- 40px` if you're supporting a `clearable` field; I was not */
  }

  .dropdown-final-filters .vs__selected-options .vs__selected{
    display: block;
    white-space: initial;
    text-overflow: ellipsis;
    overflow: hidden;

    padding-top: 9px;
  }

  .dropdown-final-filters .vs__selected-options input{
    display: none;
  }

  .dropdown-final-filters .vs__selected-options span{
    font-family: "SamsungOneBold";
    font-size: 1rem;
    color: #000;
  }

  .dropdown-final-filters .vs__actions{
    background-color: #FFF;
  }

  .dropdown-final-filters .vs__actions .vs__clear{
    display: none;
  }

  .disabledSelect .vs__dropdown-toggle{
    opacity: 0.2;
    cursor: not-allowed;
  }

  @media (min-width: 768px){
    .dropdown-final-filters-area{
      justify-content: flex-start;
    }

    .dropdown-final-filters{
      height: 60px;
      width: 100%;
    }

    .dropdown-final-filters .vs__selected-options span{
      font-size: 1.2rem;
    }

    .dropdown-final-filters  .vs__dropdown-menu .vs__dropdown-option{
      font-size: 1.2rem;
    }
  }
</style>